<template>
	<div>
		<h3>考虑到1#主变存在检修或停运的需要，接下来进行变电站系统的倒闸操作</h3>
		
		<div style="margin: 0 auto; width:1100px; height: 800px; display: flex; flex-direction: row; justify-content: center;">
			<el-row justify="center" type="flex" height="600px">
				<div class="sortcol">
					<draggable v-model="steps">
						<div v-for="(item, index) in steps" :key="index" class="sortitem4" :style="color[index]"
						@mouseenter="focus_bar = item" @mouseleave="focus_bar = ''"
						>
							<div class="step4text">{{item}}</div>
						</div>
					</draggable>
					<!-- <div class="tips"> -->
						<br><br>
						<div style="font-size: 12px; margin-bottom: 20px;">
							拖动进行排序，点击确定提交排序过程
						</div>
						<el-button type="primary" @click="judge">
							确定
						</el-button>

					<!-- </div> -->
				</div>
				<!-- <el-col :span="4">
				</el-col> -->
			</el-row>
			<div style="transform: translateX(0px); width: 850px; height: 600px; margin: 0 auto;">
				<img style="position: absolute; left: 0px;border: 1px solid;" ref="image" src="../assets/structure.svg" height="600px">
					<!-- <div 
						style="position: absolute; left: 153px; bottom: 296px; width: 15px; height: 37px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 326.5px; bottom: 271px; width: 15px; height: 37px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 542.5px; bottom: 271px; width: 15px; height: 37px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; right: 114.5px; bottom: 296px; width: 15px; height: 37px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 374px; top: 213px; width: 23px; height: 23px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 493px; top: 213px; width: 23px; height: 23px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 380px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 404px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 500px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
					></div>
					<div 
						style="position: absolute; left: 522px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
					></div> -->
					<div 
						style="position: absolute; left: 517px; top: 115px; width: 10px; height: 20px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5); "
						v-show="focus_bar === ans[0]"
					></div>
					<div 
						style="position: absolute; left: 501px; top: 145px; width: 10px; height: 20px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[2]"
					></div>
					<div 
						style="position: absolute; left: 501px; top: 172px; width: 10px; height: 20px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[1]"
					></div>
					<div 
						style="position: absolute; left: 213px; top: 385px; width: 35px; height: 17px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[3]"
					></div>
					<div 
						style="position: absolute; left: 603px; top: 385px; width: 35px; height: 17px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[4]"
					></div>
					<div 
						style="position: absolute; left: 153px; top: 267px; width: 17px; height: 35px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[5]"
					></div>
					<div 
						style="position: absolute; left: 381px; top: 145px; width: 10px; height: 20px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[6]"
					></div>
					<div 
						style="position: absolute; left: 381px; top: 172px; width: 10px; height: 20px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[7]"
					></div>
					<div 
						style="position: absolute; left: 367px; top: 115px; width: 10px; height: 20px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[8]"
					></div>
					<div 
						style="position: absolute; left: 403px; top: 172px; width: 10px; height: 20px; border: 1px solid; background-color: rgba(102, 204, 255, 0.5);"
						v-show="focus_bar === ans[9]"
					></div>
				</div>	
			</div>
		
			
		</div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
	components: {
		draggable
	},
	data() {
		return {
			active: 1,
			curstep: 0,
			focus_bar: '',
			color: [
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
			],
			steps: [
				"合上2#主变高压侧隔离开关QS142",
				"合上2#主变低压侧隔离开关QS146",
				"合上2#主变断路器QF14",
				"合上10kVI#与II#母联开关QF357",
				"合上10kVIII#与IV#母联开关QF368",
				"断开1#主变低压侧断路器QF21",
				"断开1#主变高压侧断路器QF13",
				"断开1#主变低压侧隔离开关QS136",
				"断开1#主变高压侧隔离开关QS131",
				"1#主变隔离开关接地，验电，上报，挂牌检修。",
			],
			ans: [
				"合上2#主变高压侧隔离开关QS142",
				"合上2#主变低压侧隔离开关QS146",
				"合上2#主变断路器QF14",
				"合上10kVI#与II#母联开关QF357",
				"合上10kVIII#与IV#母联开关QF368",
				"断开1#主变低压侧断路器QF21",
				"断开1#主变高压侧断路器QF13",
				"断开1#主变低压侧隔离开关QS136",
				"断开1#主变高压侧隔离开关QS131",
				"1#主变隔离开关接地，验电，上报，挂牌检修。",
			],
			success: false,
			count: 0,
			score: 0
		} 
	},
	methods: {
		judge() {
			if (this.steps.join('') === this.ans.join('')) {
				this.$message.success('排序成功！')
				this.success = true
				if (this.count === 0) this.score = 10;
				else if (this.count === 1) this.score = 8;
				else if (this.count === 2) this.score = 6;
				else if (this.count === 3) this.score = 1;
				this.$store.commit("SetScore3", { score: this.score })
				this.$store.commit("SetSteps3", this.steps.join('-'))
			} else {
				this.count += 1;
				if (this.count === 3) {
					this.$message.error('尝试机会已用完，请阅读答案。')
					this.success = true
					this.steps = this.ans
					this.score = 1;
					this.$store.commit("SetScore3", { score: this.score })
					this.$store.commit("SetSteps3", this.steps.join('-'))
					return
				}
				this.$message.error(`排序错误！还有${3 - this.count}次尝试机会。`)
				for (let i in this.steps) {
					if (this.steps[i] !== this.ans[i]) {
						this.color[i].backgroundColor = '#EE0000'
						setTimeout(() => {
							this.color[i].backgroundColor = '#ffffff'
						}, 1000);
					}
				}
			}
		}
	},
	mounted() {
		this.steps = this._.shuffle(this.steps)
	}
}	
</script>
<style>
.sortitem4 {
	width: 200px;
	height: 30px;
	display: flex;
	margin: 5px auto;
	flex-direction: column;
	justify-content: center;
	/* background-color: aquamarine; */
	border-radius: 5px;
	border: 1px solid;
	font-size: 12px;
}
</style>
